// These consts are displayed during price increase periods when the FF is ON.
export const SUBSCRIPTION_PRICE_INCREASES = { seasonal: 79.99, annual: 259.96, annualBox: 64.99 };
export const PRICE_INCREASE_DATE = '4/11/24';
